import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import ButtonAction, {
  buttonActionThemes
} from "@streeteasy/design-system/button-action";

import { calendarIcon, rightArrowImage } from "../../assets";

export const Wrapper = styled.div`
  align-items: center;
  background: ${colors.WHITE};
  border: 1px solid ${colors.GRAY_LIGHT};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
  display: flex;
  height: 73px;
  margin: 10px 0 31px;
  padding: 15px 24px;
  position: relative;
  width: 641px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 51px;
    width: 100%;
    padding: 0 16px;
  }
`;

export const InfoBox = styled.div`
  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding: 0 0 2px 0;
  }
`;

export const OHTime = styled(typography.Body)`
  color: ${colors.TEXT_SECONDARY};

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const Title = styled(typography.Caps)`
  color: ${colors.BRAND};

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    line-height: 20px;
  }
`;

export const CalendarIcon = styled.img.attrs({
  alt: "open houses",
  "aria-hidden": true,
  src: calendarIcon
})`
  color: ${colors.BRAND};
  margin: 0 18px 0 0;
  padding: 0;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    height: 20px;
    margin: 0 10px 0 0;
  }
`;

export const ArrowIcon = styled.img.attrs({
  alt: "view open houses",
  "aria-hidden": true,
  src: rightArrowImage
})`
  color: ${colors.BRAND};
  margin: 0 18px 0 0;
`;

export const CallModalButton = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  height: 32px;
  min-width: 101px;
  padding: 0 12px;
  position: absolute;
  right: 22px;
  top: 20px;
  width: 160px;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    display: none;
  }
`;

export const CallModalButtonMWeb = styled(ButtonAction).attrs({
  type: "button",
  theme: buttonActionThemes.SECONDARY
})`
  background: none;
  border: none;
  bottom: 0;
  display: none;
  height: 49px;
  justify-content: flex-end;
  left: 0;
  min-width: auto;
  outline: none;
  padding: 18px 0 0 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;

  &:hover,
  &:active {
    background: none;
    border: none;
    outline: none;
  }

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    display: flex;
  }
`;
